import React, { useContext } from 'react';
import { useSelector } from 'react-redux'; 

import { Field, Validators } from '../../core/inputElements';
import { FormContext, StepContext, ScrollableSection, Section, } from '../../core/layoutElements'; 

const STEPID = "notes";
const TITLE = "steps_Notes"; // localization string key for the page name

const SECTION_IMPORTANTNOTES = "importantNotes";

const FIELD_ID_NOTES = "acceptNotes";

export const validations = {
	[SECTION_IMPORTANTNOTES]: {
		[FIELD_ID_NOTES] : [ Validators.isChecked ],
	},
}

export const Notes = () => {
	const {language} = useSelector(store => store.session); 
	const {formLocalization} = useContext(FormContext); 

	return (
		<StepContext.Provider value={{stepId: STEPID, title: TITLE, validations: validations}}>
			<ScrollableSection id="termsSection" titleText={formLocalization.termsAndConditions} notes={formLocalization.termsAndConditions_body()} numbered={false}
								termsAndConditionsHeading={formLocalization.termsAndConditionsOf}> 
				<Field.Checkbox id="termsAndConditions" label={formLocalization.readAndUnderstandTerms} required />  
			</ScrollableSection> 
			<ScrollableSection id="picsSection" titleText={formLocalization.PICS} notes={formLocalization.SSS_PICSContent()} numbered={false}
								generalTerms={false}> 
				<Field.Checkbox id="PICS" label={language.readAndUnderstandPICS} required /> 
			</ScrollableSection> 
		</StepContext.Provider>
	)
}

export default {
	stepId: STEPID,
	title: TITLE,
	content: Notes,
	validations: validations,
	skipConfirm: true,
	hideSavePrint: true,
};
